import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Footer = () => {
    return (
        <footer className="bg-dark text-white py-2 small">
            <Container>
                <Row>
                    <Col md={4} className='small'>
                        <p></p>
                    </Col>
                    <Col md={4} className='small'>
                        <p>&copy; {new Date().getFullYear()} B2X. All rights reserved.</p>
                    </Col>
                    <Col md={4} className="text-md-end small">
                        <a href="/privacy" className="text-white text-decoration-none me-3">Privacy Policy</a>
                        <a href="/terms" className="text-white text-decoration-none">Terms of Service</a>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;